<template>
  <a-card size="small" type="inner">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" @click="handleDownload" :style="{ display: expand ? 'inline-block' : 'none'}"/>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>
    <a-skeleton :loading="loading" active>
      <h3 class="text-center">Summary for
        <strong v-if="filters.date.length > 0">
          {{ moment(filters.date[0], 'YYYY-MM-DD').format('DD MMMM YYYY') }} - {{ moment(filters.date[1], 'YYYY-MM-DD').format('DD MMMM YYYY') }}
        </strong>
        <strong v-else>{{ moment().format("MMMM YYYY") }}</strong>
      </h3>
      <a-divider dashed/>
      <a-table :columns="columns"
               :dataSource="items.data"
               rowKey="product_name"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">

        <h4 slot="name" slot-scope="name">{{ name }}</h4>
        <h4 slot="count" slot-scope="record" class="text-center">{{ number(record.count) }}</h4>
        <h4 class="text-center" slot="bills" slot-scope="record">{{ number(record.total_bills) }}</h4>

        <h4 slot="biller_price" slot-scope="record"> <currency :amount="record.biller_price" /> </h4>
        <h4 slot="client_af" slot-scope="record"><currency :amount="record.client_admin_fee" /></h4>
        <h4 slot="client_sf" slot-scope="record"><currency :amount="record.client_share_fee" /></h4>
        <h4 slot="biller_af" slot-scope="record"><currency :amount="record.biller_admin_fee" /></h4>
        <h4 slot="biller_sf" slot-scope="record"><currency :amount="record.biller_share_fee" /></h4>

        <h4 slot="profit" slot-scope="record"> <currency :amount="record.profit"/></h4>

      </a-table>
    </a-skeleton>
  </a-card>
</template>

<script>
const columns = [
  {
    dataIndex: 'product_name',
    key: 'product_name',
    title: 'Product Name',
    scopedSlots: {customRender: 'name'}
  },
  {
    key: 'count',
    title: 'Count',
    align: 'center',
    width: 100,
    scopedSlots: {customRender: 'count'}
  },
  {
    key: 'bills',
    title: 'Bills',
    align: 'center',
    width: 100,
    scopedSlots: {customRender: 'bills'}
  },
  {
    key: 'biller_price',
    title: 'Biller Price',
    scopedSlots: {customRender: 'biller_price'}
  }, {
    key: 'client_af',
    title: 'Client AF',
    scopedSlots: {customRender: 'client_af'}
  } , {
    key: 'client_sf',
    title: 'Client SF',
    scopedSlots: {customRender: 'client_sf'}
  }, {
    key: 'biller_af',
    title: 'Biller AF',
    scopedSlots: {customRender: 'biller_af'}
  }, {
    key: 'biller_sf',
    title: 'Biller SF',
    scopedSlots: {customRender: 'biller_sf'}
  }, {
    key: 'profit',
    title: 'Profit',
    scopedSlots: {customRender: 'profit'}
  }
];

export default {
  name: "product-transaction-summary",
  computed: {
    uri() {
      return this.routeUri('hyperion.transaction.summary.product')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.transaction.summary.export.product') + '?' + this.$qs.stringify(params)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      filters: {
        page: 1,
        per_page: 10,
        date: [],
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        date: []
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleDownload() {
      window.open(this.exportUri, '_blank')
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>

</style>
